var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_746_543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18L6.75 14.625V10.785L0.75 4.035V2.25C0.75 1.65326 0.987053 1.08097 1.40901 0.65901C1.83097 0.237053 2.40326 0 3 0L15 0C15.5967 0 16.169 0.237053 16.591 0.65901C17.0129 1.08097 17.25 1.65326 17.25 2.25V4.035L11.25 10.785V18ZM8.25 13.875L9.75 15V10.215L15.75 3.465V2.25C15.75 2.05109 15.671 1.86032 15.5303 1.71967C15.3897 1.57902 15.1989 1.5 15 1.5H3C2.80109 1.5 2.61032 1.57902 2.46967 1.71967C2.32902 1.86032 2.25 2.05109 2.25 2.25V3.465L8.25 10.215V13.875Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_746_543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.9d34ba993765c0970d467c6641cd322d.svg";
export { ForwardRef as ReactComponent };